export default {
    methods: {
        async requestData({
            service, storage, method, methodHandler,
        }) {
            const retrievedData = await service();

            if (method && methodHandler) {
                this[storage] = retrievedData[method](methodHandler);
            } else {
                this[storage] = retrievedData;
            }

            if (typeof this.pageloaded === 'function') {
                this.pageloaded();
            }

            return retrievedData;
        },
    },
};
